let timerId;
$('.members_image').hover(function() {
  const slides = $(this).find(".img_wrap img");
  const slideLength = slides.length;
  if( slideLength > 1) {
    let now = 0;
    let next = 1;
    const fade = 1000;
    const show = 1500;
    slides.hide();
    slides.eq(0).show();
    timerId = setInterval(function(){
      slides.eq(now % slideLength).fadeOut(fade);
      slides.eq(next % slideLength).fadeIn(fade);
      now++;
      next++;
    }, show);
  }
}, function() {
  clearInterval(timerId);
});

/*
$('.collection_lives').hide();
$('.collection_movie').hide();
$('.blog_articles').show();
$('.blog_link').addClass('link_active');
$('.live_link').removeClass('link_active');
$('.movie_link').removeClass('link_active');
  
$('.live_link').click(function(){
  $('.collection_lives').show();
  $('.blog_articles').hide();
  $('.collection_movie').hide();
  $('.live_link').addClass('link_active');
  $('.blog_link').removeClass('link_active');
  $('.movie_link').removeClass('link_active');
});

$('.blog_link').click(function(){
  $('.collection_lives').hide();
  $('.collection_movie').hide();
  $('.blog_articles').show();
  $('.live_link').removeClass('link_active');
  $('.movie_link').removeClass('link_active');
  $('.blog_link').addClass('link_active');
});

$('.movie_link').click(function(){
  $('.collection_lives').hide();
  $('.blog_articles').hide();
  $('.collection_movie').show();
  $('.live_link').removeClass('link_active');
  $('.blog_link').removeClass('link_active');
  $('.movie_link').addClass('link_active');
});
*/

const ag2videoSettings = {
  classWrap: 'ag2video',
  classActive: 'ag2videoOn'
};
let currentVideo = null;

const ag2video = {
  on: function(t){
    $(t).addClass(ag2videoSettings.classActive);
    currentVideo = $(t).find('video')[0];

    currentVideo.play();
  },
  off: function(t){

    currentVideo.pause();
    currentVideo.load();

    $(t).removeClass(ag2videoSettings.classActive);
    currentVideo = null;
  }
};

$('.'+ag2videoSettings.classWrap).on('mouseover', function(e){
  if(!$(this).hasClass(ag2videoSettings.classActive)) ag2video.on(this);
});
  
$('.'+ag2videoSettings.classWrap).on('mouseout', function(e){
  if($(this).hasClass(ag2videoSettings.classActive)) ag2video.off(this);
});

$('.'+ag2videoSettings.classWrap).on('touchstart', function(e){
  ag2video.off('.ag2video');
  if(!$(this).hasClass(ag2videoSettings.classActive)) {
    ag2video.on(this);
  } else {
    ag2video.off(this);
  }
});

$('video').prop('muted', false);

var doc = document;
var head = doc.getElementsByTagName("head")[0];
var meta = doc.createElement("meta");
meta.setAttribute("name","robots");
meta.setAttribute("content","noindex");
head.appendChild(meta);